import { render, staticRenderFns } from "./ProtesisFijaRemovible.vue?vue&type=template&id=60930dea&scoped=true"
import script from "./ProtesisFijaRemovible.vue?vue&type=script&lang=js"
export * from "./ProtesisFijaRemovible.vue?vue&type=script&lang=js"
import style0 from "./ProtesisFijaRemovible.vue?vue&type=style&index=0&id=60930dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60930dea",
  null
  
)

export default component.exports